import * as React from "react";
import { CssBaseline, Box, Typography } from "@mui/material";
import { StandardPageHead } from "../components/Heads/StandardPageHead.tsx";
import { SelectVenuesButton } from "../components/Buttons/SelectVenuesButton.tsx";

type NotFoundPageProps = {
  title?: string;
  description?: string;
  backTo?: string;
  backLabel?: string;
};

export const NotFoundPage: React.FC<NotFoundPageProps> = ({
  title = "Page not found | CinemaGuide",
  description = "Sorry — we couldn’t find the page you were looking for.",
}) => {
  return (
    <>
      <CssBaseline />
      <StandardPageHead
        title={title}
        description={description}
        pageUrl={typeof window !== "undefined" ? window.location.href : ""}
      />

      <Box
        sx={{
          width: { xs: "100%", md: "70%" },
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mx: "auto",
          textAlign: "center",
          gap: 2,
        }}
      >
        <Typography
          variant="h2"
          sx={{ fontWeight: 800, fontSize: { xs: "x-large", md: "xx-large" } }}
        >
          404
        </Typography>

        <Typography
          variant="h5"
          color="text.secondary"
          sx={{ fontSize: { xs: "large", md: "x-large" } }}
        >
          {description}
        </Typography>

        <Box sx={{ mt: 2 }}>
          {/* <Button component={RouterLink} to={backTo} variant="contained">
            {backLabel}
          </Button> */}
          <SelectVenuesButton />
        </Box>
      </Box>
    </>
  );
};
